import { apiRequest } from "./api";
import { Store } from "./store";

export type VisData = Record<string, string>;

export class VisDataFetcher {
    private cache: VisData = {};
    public isReady = false;

    constructor(
        private readonly store: Store<string>,
        public readonly keyPrefix = ":",
        private readonly visId: number,
        data?: VisData,
    ) {
        if (data) {
            this.setData(data);
        }
    }

    public async fetch(): Promise<void> {
        const data = await apiRequest<VisData>(`/v1/vis/${this.visId}/data/`, "get");
        this.setData(data);
    }

    public async save(key: string, value: string): Promise<void> {
        const body = JSON.stringify({ code: key, value });
        await apiRequest<object>(`/v1/vis/${this.visId}/data/save/`, "post", { body });
        this.cache[key] = value;
        this.store.set(this.keyPrefix + key, value);
    }

    public get(key: string): string | undefined {
        return this.cache[key];
    }

    public async editAsync(key: string, title?: string): Promise<void> {
        // const { value } = (await Swal.fire({
        //     title: title ?? "Change name",
        //     input: "text",
        //     inputValue: this.get(key),
        // })) as { value: string | undefined };
        const value = prompt(title ?? "Change name", this.get(key));
        if (!value) {
            return;
        }
        await this.save(key, value);
    }

    public edit(key: string, title?: string): void {
        // eslint-disable-next-line no-console
        this.editAsync(key, title).catch(console.error);
    }

    private setData(data: VisData): void {
        this.cache = { ...this.cache, ...data };
        this.store.setMany(
            Object.fromEntries(Object.entries(data).map(([k, v]) => [this.keyPrefix + k, v])),
        );
        this.isReady = true;
    }
}
